import { TableColumn } from 'react-data-table-component';

interface IProps {
  id: string;
  name: string;
  questionsQty: number;
  entityName?: string;
}

export const makeColumnsEvaluationCriteria = (): TableColumn<IProps>[] => {
  return [
    {
      name: 'Nome',
      selector: (row) => row.name,
      sortField: 'name',
      sortable: true,
      width: '35%',
      wrap: true,
    },
    {
      name: 'Organização',
      selector: (row) => row.entityName,
      sortField: 'entityName',
      sortable: true,
      width: '35%',
      wrap: true,
    },
    {
      name: 'Questões',
      selector: (row) => row.questionsQty,
      cell: (row) => {
        return <span className="mx-3 fw-medium">{row.questionsQty}</span>;
      },
      sortField: 'questionsQty',
      sortable: true,
    },
  ];
};
